export const beforeEachRoute = (store) => async (to, from, next) => {
    store.dispatch('Backdrop/removeAllComponents');

    next();
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const afterEachRoute = (store) => async (to, from) => {
    let mainEventId = to.params.mainEventId;
    if (to.meta?.resolveMainEventId) {
        mainEventId = to.meta.resolveMainEventId(to);
    }

    if (mainEventId && (to.meta?.scopeWithMainEventId ?? true)) {
        store.dispatch('Routing/setCurrentMainEventId', mainEventId);
    }
};
